"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.writeClientInvocationDescriptor = exports.readClientInvocationDescriptor = exports.BuildClientInvocation = void 0;
const CLIENT_INVOCATION_DESCRIPTOR_SYM = Symbol.for("@leavy/cq-core/CLIENT_INVOCATION_DESCRIPTOR");
function BuildClientInvocation(descriptor) {
    const holder = {
        [descriptor.type.name]: class extends descriptor.type {
        },
    };
    writeClientInvocationDescriptor(holder[descriptor.type.name], descriptor);
    return holder[descriptor.type.name];
}
exports.BuildClientInvocation = BuildClientInvocation;
function readClientInvocationDescriptor(invocation) {
    const descriptor = invocation[CLIENT_INVOCATION_DESCRIPTOR_SYM];
    return descriptor !== null && descriptor !== void 0 ? descriptor : null;
}
exports.readClientInvocationDescriptor = readClientInvocationDescriptor;
function writeClientInvocationDescriptor(invocation, descriptor) {
    invocation[CLIENT_INVOCATION_DESCRIPTOR_SYM] = descriptor;
}
exports.writeClientInvocationDescriptor = writeClientInvocationDescriptor;
//# sourceMappingURL=ClientInvocationBuilder.js.map